angular.module('bmsApp.merrymaids').factory('MMEnquiryRejectedReasonSvc', function (CRUDSvc) {

	return {
		options: function (params) {
			return CRUDSvc.get('api/mmEnquiryRejectedReason/options', params);
		}
	}

});
